import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage';
import { AuthCallbackPage } from '@/pages/AuthCallbackPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { ProjectCategoriesPage } from '@/pages/ProjectCategoriesPage';
import { BlogPage } from '@/pages/BlogPage';
import { ContentsPage } from '@/pages/ContentsPage';
import { InfluencersPage } from '@/pages/InfluencersPage';
import { TeamPage } from '@/pages/TeamPage';
import { CareersPage } from '@/pages/CareersPage';
import { ApplicationsPage } from '@/pages/ApplicationsPage';
import { ServicesPage } from '@/pages/ServicesPage';
import { TopicsPage } from '@/pages/TopicsPage';
import { MediaPage } from '@/pages/MediaPage';
import { InboxPage } from '@/pages/InboxPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { SiteSettingsPage } from '@/pages/SiteSettingsPage';
import { AdminsPage } from '@/pages/AdminsPage';
import { AboutContentPage } from '@/pages/AboutContentPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  {
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'site', element: <SiteSettingsPage /> },
      { path: 'about', element: <AboutContentPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'project-categories', element: <ProjectCategoriesPage /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'contents', element: <ContentsPage /> },
      { path: 'influencers', element: <InfluencersPage /> },
      { path: 'team', element: <TeamPage /> },
      { path: 'careers', element: <CareersPage /> },
      { path: 'applications', element: <ApplicationsPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'topics', element: <TopicsPage /> },
      { path: 'media', element: <MediaPage /> },
      { path: 'inbox', element: <InboxPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'admins', element: <AdminsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);